import { ArrowBack, Close } from '@mui/icons-material'
import {
  AppBar,
  Box,
  Container,
  IconButton,
  Stack,
  Toolbar,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import { HomeIcon, MainLogo } from 'components/images'
import { SearchInput } from './SearchInput'
import { useAppSettings, useRedirectToHomePage } from 'hooks'
import { isEmpty } from 'lodash'
import { KSmallIconButton } from 'components/core/KButton'

interface SearchHeaderProps {
  onClose: () => void
  handleSearch: (value: string) => void
}

export const SearchHeader = ({ onClose, handleSearch }: SearchHeaderProps) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const redirectToHomePage = useRedirectToHomePage()

  const handleLogoClick = () => {
    redirectToHomePage()
  }

  const { appSettings } = useAppSettings()
  const handleHomeClick = () => {
    window.location.href = appSettings?.home
  }

  if (isMobile) {
    return (
      <AppBar
        position="static"
        sx={{
          boxShadow: theme.custom.shadows[0],
          background: theme.palette.common.white,
        }}
      >
        <Container maxWidth="lg">
          <Toolbar
            disableGutters
            sx={{ gap: 1, justifyContent: 'space-between' }}
          >
            <KSmallIconButton onClick={onClose}>
              <ArrowBack />
            </KSmallIconButton>
            <SearchInput
              autoFocus
              onChange={(e) => handleSearch(e.target.value)}
              sx={{ maxWidth: 574 }}
            />
          </Toolbar>
        </Container>
      </AppBar>
    )
  }

  return (
    <AppBar
      position="static"
      sx={{
        boxShadow: theme.custom.shadows[0],
        background: theme.palette.common.white,
      }}
    >
      <Container maxWidth="lg">
        <Toolbar
          disableGutters
          sx={{ gap: 3, justifyContent: 'space-between' }}
        >
          {!isEmpty(appSettings?.home) ? (
            <IconButton color="primary" onClick={handleHomeClick}>
              <HomeIcon fontSize="large" />
            </IconButton>
          ) : (
            <MainLogo width={84} onClick={handleLogoClick} />
          )}

          <Stack
            direction="row"
            spacing={1}
            sx={{ flexGrow: 1, maxWidth: 612 }}
          >
            <SearchInput
              autoFocus
              onChange={(e) => handleSearch(e.target.value)}
            />

            <IconButton onClick={onClose} color="primary">
              <Close />
            </IconButton>
          </Stack>
          <Box />
        </Toolbar>
      </Container>
    </AppBar>
  )
}
